import { render, staticRenderFns } from "./taskSkillMap.vue?vue&type=template&id=fbfd03aa&scoped=true&"
import script from "./taskSkillMap.vue?vue&type=script&lang=js&"
export * from "./taskSkillMap.vue?vue&type=script&lang=js&"
import style0 from "./taskSkillMap.vue?vue&type=style&index=0&id=fbfd03aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfd03aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbfd03aa')) {
      api.createRecord('fbfd03aa', component.options)
    } else {
      api.reload('fbfd03aa', component.options)
    }
    module.hot.accept("./taskSkillMap.vue?vue&type=template&id=fbfd03aa&scoped=true&", function () {
      api.rerender('fbfd03aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/task/taskSkillMap.vue"
export default component.exports